import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { useCallback } from 'react'
import { SelectOption } from '../../../../model/selectOption'
import { Select } from '../../../../components/select'
import {
  renderOption as renderOptionDefault,
  renderOptionWithIcon,
} from '../../../../components/select/variations'

type SelectCellProps = {
  value: string | undefined
  onChange?: (v: string | undefined) => void
  options: SelectOption[]
  displayIcon?: boolean
  clearable?: boolean
  renderOption?: (option: SelectOption) => JSX.Element
  renderValue?: (value: SelectOption | undefined) => JSX.Element
} & CellPropsBase

export const SelectCell = ({
  label,
  help,
  options,
  value,
  onChange,
  cellWidth,
  required,
  editable = true,
  edited,
  validationErrors,
  displayIcon = false,
  clearable = true,
  renderOption: _renderOption,
  renderValue: _renderValue,
}: SelectCellProps) => {
  const renderOption = useCallback(
    (option: SelectOption) => {
      if (_renderOption) {
        return _renderOption(option)
      }
      if (displayIcon) {
        return renderOptionWithIcon(option)
      }
      return renderOptionDefault(option)
    },
    [displayIcon, _renderOption]
  )
  const renderValue = useCallback(
    (value: SelectOption | undefined) => {
      if (_renderValue) {
        return _renderValue(value)
      }
      if (!value) {
        return <></>
      }
      if (displayIcon) {
        return renderOptionWithIcon(value)
      }
      return <>{value.name}</>
    },
    [displayIcon, _renderValue]
  )
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <Select
          value={value}
          onChange={onChange}
          options={options}
          clearable={clearable}
          disabled={!editable}
          renderOption={renderOption}
          renderValue={renderValue}
        />
      </CellValueArea>
    </FormCell>
  )
}
